import { createRoute } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { AnalysisCardView } from "@/pages/AnalysisCardView";
import { Route as RootRoute } from "./__root";

/**
 * /analyses/$analysisId (TM-4c1fb82b) — страница разбора по списку встреч.
 * Гейтится через `list_analysis_view` (admin-only). Открывается кликом по
 * строке реестра «Анализы».
 */
export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/analyses/$analysisId",
  component: AnalysisCardRoute,
});

function AnalysisCardRoute() {
  const { analysisId } = Route.useParams();
  return (
    <RoleGuard action="list_analysis_view">
      <AnalysisCardView analysisId={analysisId} />
    </RoleGuard>
  );
}
